import React from "react";

const NoLocationFound = () => {
  return (
    <svg
      width="269"
      height="293"
      viewBox="0 0 269 293"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M257.775 171.333C232.263 230.974 164.92 256.592 112.156 252.224C97.7496 251.031 68.7629 248.632 46.1299 227.225C2.66468 186.114 9.35878 100.181 50.9674 49.5885C56.3257 43.0732 93.4153 -0.578519 151.212 0.00581267C193.528 0.433647 223.23 24.3415 226.841 27.3199C231.403 31.0825 241.466 40.0236 250.535 54.2081C271.844 87.5367 273.717 134.064 257.775 171.333Z"
        fill="url(#paint0_linear_4807_62432)"
      />
      <path
        d="M115.82 69.5667C115.784 67.7751 114.201 66.3008 112.262 66.3008H38.9524C36.9869 66.3008 35.0566 67.8519 35.0566 69.6679V231.98C35.0566 232.853 35.6014 233.691 36.2709 234.308C36.9404 234.925 37.9323 235.27 38.878 235.268L115.527 235.074C116.481 235.072 117.415 234.716 118.082 234.086C118.749 233.456 119.125 232.586 119.107 231.705L115.82 69.5667Z"
        fill="#91B3FA"
      />
      <g opacity="0.5">
        <path
          d="M61.8312 85.4278L40.9469 85.402L40.7812 75.5117H61.6858L61.8312 85.4278Z"
          fill="white"
        />
        <path
          d="M85.2396 85.4229L64.3764 85.3969L64.2334 75.5117H85.1169L85.2396 85.4229Z"
          fill="white"
        />
        <path
          d="M108.626 85.4179L87.7833 85.3919L87.6631 75.5117H108.526L108.626 85.4179Z"
          fill="white"
        />
        <path
          d="M62.092 103.18L41.2442 103.193L41.0791 93.3672L61.9471 93.3594L62.092 103.18Z"
          fill="white"
        />
        <path
          d="M85.4606 103.168L64.6337 103.18L64.4912 93.3594L85.3383 93.3516L85.4606 103.168Z"
          fill="white"
        />
        <path
          d="M108.805 103.153L87.9987 103.165L87.8789 93.3498L108.705 93.3418L108.805 103.153Z"
          fill="white"
        />
        <path
          d="M62.3522 120.811L41.5405 120.831L41.376 111.039L62.2078 111.023L62.3522 120.811Z"
          fill="white"
        />
        <path
          d="M85.6798 120.788L64.889 120.808L64.7471 111.022L85.5579 111.006L85.6798 120.788Z"
          fill="white"
        />
        <path
          d="M108.984 120.766L88.2141 120.786L88.0947 111.004L108.885 110.988L108.984 120.766Z"
          fill="white"
        />
        <path
          d="M62.6114 138.38L41.8358 138.408L41.6719 128.651L62.4674 128.627L62.6114 138.38Z"
          fill="white"
        />
        <path
          d="M85.8981 138.35L65.1434 138.378L65.002 128.625L85.7767 128.602L85.8981 138.35Z"
          fill="white"
        />
        <path
          d="M109.162 138.318L88.4285 138.346L88.3096 128.598L109.063 128.574L109.162 138.318Z"
          fill="white"
        />
        <path
          d="M62.8696 155.889L42.1302 155.925L41.9668 146.201L62.7263 146.17L62.8696 155.889Z"
          fill="white"
        />
        <path
          d="M86.1164 155.85L65.3978 155.885L65.2568 146.166L85.9955 146.135L86.1164 155.85Z"
          fill="white"
        />
        <path
          d="M109.34 155.81L88.6421 155.845L88.5234 146.131L109.241 146.1L109.34 155.81Z"
          fill="white"
        />
        <path
          d="M63.1271 173.337L42.4236 173.38L42.2607 163.69L62.9842 163.65L63.1271 173.337Z"
          fill="white"
        />
        <path
          d="M86.3332 173.287L65.6502 173.33L65.5098 163.645L86.2125 163.605L86.3332 173.287Z"
          fill="white"
        />
        <path
          d="M109.517 173.239L88.8545 173.282L88.7363 163.602L109.418 163.562L109.517 173.239Z"
          fill="white"
        />
        <path
          d="M63.3837 190.725L42.716 190.776L42.5537 181.119L63.2413 181.072L63.3837 190.725Z"
          fill="white"
        />
        <path
          d="M86.5499 190.667L65.9027 190.719L65.7627 181.066L86.4297 181.02L86.5499 190.667Z"
          fill="white"
        />
        <path
          d="M109.694 190.61L89.067 190.661L88.9492 181.014L109.596 180.967L109.694 190.61Z"
          fill="white"
        />
        <path
          d="M63.6395 208.053L43.0074 208.112L42.8457 198.488L63.4976 198.434L63.6395 208.053Z"
          fill="white"
        />
        <path
          d="M86.7657 207.988L66.1542 208.046L66.0146 198.427L86.646 198.373L86.7657 207.988Z"
          fill="white"
        />
        <path
          d="M109.87 207.923L89.2784 207.981L89.1611 198.367L109.772 198.312L109.87 207.923Z"
          fill="white"
        />
        <path
          d="M63.8944 225.323L43.2978 225.389L43.1367 215.798L63.7529 215.736L63.8944 225.323Z"
          fill="white"
        />
        <path
          d="M86.9808 225.25L66.4046 225.316L66.2656 215.73L86.8615 215.668L86.9808 225.25Z"
          fill="white"
        />
        <path
          d="M110.045 225.175L89.489 225.241L89.3721 215.66L109.947 215.598L110.045 225.175Z"
          fill="white"
        />
      </g>
      <path
        d="M238.314 87.055C238.284 85.3823 236.974 84.0059 235.368 84.0059H174.674C173.046 84.0059 171.448 85.4541 171.448 87.1497V238.691C171.448 239.507 171.899 240.289 172.454 240.865C173.008 241.441 173.829 241.763 174.612 241.761L238.071 241.581C238.861 241.578 239.634 241.246 240.186 240.658C240.739 240.07 241.05 239.257 241.035 238.435L238.314 87.055Z"
        fill="#91B3FA"
      />
      <g opacity="0.5">
        <path
          d="M193.616 101.863L176.326 101.839L176.188 92.6055H193.496L193.616 101.863Z"
          fill="white"
        />
        <path
          d="M212.997 101.859L195.724 101.835L195.605 92.6055H212.895L212.997 101.859Z"
          fill="white"
        />
        <path
          d="M232.358 101.854L215.102 101.83L215.003 92.6055H232.275L232.358 101.854Z"
          fill="white"
        />
        <path
          d="M193.833 118.439L176.572 118.45L176.436 109.277L193.713 109.27L193.833 118.439Z"
          fill="white"
        />
        <path
          d="M213.179 118.425L195.936 118.436L195.818 109.267L213.078 109.26L213.179 118.425Z"
          fill="white"
        />
        <path
          d="M232.507 118.412L215.282 118.424L215.183 109.259L232.425 109.252L232.507 118.412Z"
          fill="white"
        />
        <path
          d="M194.047 134.899L176.817 134.918L176.681 125.776L193.928 125.762L194.047 134.899Z"
          fill="white"
        />
        <path
          d="M213.361 134.877L196.148 134.896L196.03 125.759L213.26 125.744L213.361 134.877Z"
          fill="white"
        />
        <path
          d="M232.654 134.857L215.458 134.876L215.359 125.743L232.572 125.729L232.654 134.857Z"
          fill="white"
        />
        <path
          d="M194.262 151.301L177.062 151.328L176.926 142.217L194.143 142.195L194.262 151.301Z"
          fill="white"
        />
        <path
          d="M213.541 151.273L196.358 151.299L196.241 142.194L213.441 142.172L213.541 151.273Z"
          fill="white"
        />
        <path
          d="M232.803 151.243L215.637 151.27L215.538 142.168L232.721 142.146L232.803 151.243Z"
          fill="white"
        />
        <path
          d="M194.476 167.649L177.305 167.682L177.17 158.604L194.357 158.574L194.476 167.649Z"
          fill="white"
        />
        <path
          d="M213.722 167.611L196.569 167.644L196.452 158.57L213.622 158.541L213.722 167.611Z"
          fill="white"
        />
        <path
          d="M232.949 167.573L215.813 167.607L215.715 158.537L232.868 158.508L232.949 167.573Z"
          fill="white"
        />
        <path
          d="M194.689 183.94L177.548 183.98L177.413 174.933L194.57 174.896L194.689 183.94Z"
          fill="white"
        />
        <path
          d="M213.901 183.894L196.778 183.935L196.661 174.892L213.801 174.855L213.901 183.894Z"
          fill="white"
        />
        <path
          d="M233.096 183.849L215.989 183.889L215.892 174.851L233.015 174.814L233.096 183.849Z"
          fill="white"
        />
        <path
          d="M194.902 200.174L177.791 200.222L177.656 191.206L194.784 191.162L194.902 200.174Z"
          fill="white"
        />
        <path
          d="M214.082 200.121L196.988 200.169L196.872 191.157L213.983 191.113L214.082 200.121Z"
          fill="white"
        />
        <path
          d="M233.242 200.068L216.165 200.115L216.067 191.108L233.161 191.064L233.242 200.068Z"
          fill="white"
        />
        <path
          d="M195.113 216.352L178.031 216.407L177.897 207.422L194.996 207.371L195.113 216.352Z"
          fill="white"
        />
        <path
          d="M214.26 216.291L197.196 216.346L197.08 207.365L214.161 207.314L214.26 216.291Z"
          fill="white"
        />
        <path
          d="M233.388 216.23L216.34 216.285L216.243 207.308L233.307 207.258L233.388 216.23Z"
          fill="white"
        />
        <path
          d="M195.324 232.474L178.272 232.536L178.139 223.581L195.207 223.523L195.324 232.474Z"
          fill="white"
        />
        <path
          d="M214.438 232.405L197.402 232.467L197.287 223.517L214.339 223.459L214.438 232.405Z"
          fill="white"
        />
        <path
          d="M233.533 232.336L216.515 232.398L216.418 223.452L233.453 223.395L233.533 232.336Z"
          fill="white"
        />
      </g>
      <path
        d="M248.989 145.033C248.977 144.361 248.611 143.72 247.975 143.258C247.339 142.795 246.486 142.549 245.61 142.576L179.066 144.624C177.924 144.659 177.029 145.391 177.056 146.268L180.434 255.453L247.72 254.823C248.583 254.814 249.406 254.543 250.008 254.069C250.61 253.595 250.941 252.956 250.929 252.294L248.989 145.033Z"
        fill="#BDD0FB"
      />
      <g opacity="0.37">
        <path
          d="M195.213 162.05L185.381 162.047L184.892 151.139H194.787L195.213 162.05Z"
          fill="white"
        />
        <path
          d="M210.536 162.021L201.182 162.017L200.794 151.139H210.208L210.536 162.021Z"
          fill="white"
        />
        <path
          d="M226.199 161.991L216.473 161.988L216.183 151.139H225.971L226.199 161.991Z"
          fill="white"
        />
        <path
          d="M241.777 161.962L232.103 161.959L231.912 151.139H241.646L241.777 161.962Z"
          fill="white"
        />
        <path
          d="M195.907 179.796L186.177 179.844L185.698 169.181L195.49 169.15L195.907 179.796Z"
          fill="white"
        />
        <path
          d="M211.07 179.721L201.814 179.767L201.434 169.133L210.749 169.104L211.07 179.721Z"
          fill="white"
        />
        <path
          d="M226.571 179.644L216.946 179.692L216.661 169.085L226.347 169.055L226.571 179.644Z"
          fill="white"
        />
        <path
          d="M241.988 179.566L232.415 179.614L232.228 169.036L241.861 169.006L241.988 179.566Z"
          fill="white"
        />
        <path
          d="M196.588 197.139L186.959 197.217L186.489 186.771L196.179 186.711L196.588 197.139Z"
          fill="white"
        />
        <path
          d="M211.595 197.019L202.434 197.092L202.062 186.674L211.28 186.617L211.595 197.019Z"
          fill="white"
        />
        <path
          d="M226.937 196.896L217.41 196.972L217.131 186.581L226.717 186.521L226.937 196.896Z"
          fill="white"
        />
        <path
          d="M242.197 196.773L232.721 196.849L232.537 186.485L242.072 186.426L242.197 196.773Z"
          fill="white"
        />
        <path
          d="M197.254 214.13L187.724 214.235L187.264 204L196.854 203.912L197.254 214.13Z"
          fill="white"
        />
        <path
          d="M212.108 213.968L203.04 214.067L202.675 203.859L211.799 203.775L212.108 213.968Z"
          fill="white"
        />
        <path
          d="M227.295 213.801L217.864 213.904L217.591 203.722L227.08 203.635L227.295 213.801Z"
          fill="white"
        />
        <path
          d="M242.4 213.634L233.02 213.737L232.84 203.581L242.278 203.494L242.4 213.634Z"
          fill="white"
        />
        <path
          d="M197.907 230.783L188.473 230.915L188.022 220.885L197.515 220.77L197.907 230.783Z"
          fill="white"
        />
        <path
          d="M212.612 230.579L203.635 230.704L203.277 220.7L212.309 220.59L212.612 230.579Z"
          fill="white"
        />
        <path
          d="M227.645 230.37L218.309 230.5L218.041 220.52L227.434 220.406L227.645 230.37Z"
          fill="white"
        />
        <path
          d="M242.6 230.162L233.313 230.291L233.137 220.336L242.48 220.223L242.6 230.162Z"
          fill="white"
        />
        <path
          d="M198.547 247.105L189.207 247.262L188.766 237.43L198.162 237.289L198.547 247.105Z"
          fill="white"
        />
        <path
          d="M213.104 246.861L204.217 247.01L203.866 237.203L212.807 237.068L213.104 246.861Z"
          fill="white"
        />
        <path
          d="M227.988 246.612L218.745 246.767L218.482 236.984L227.782 236.844L227.988 246.612Z"
          fill="white"
        />
        <path
          d="M242.796 246.363L233.601 246.517L233.428 236.758L242.678 236.619L242.796 246.363Z"
          fill="white"
        />
      </g>
      <path
        d="M71.7837 103.056C71.7631 101.998 70.8625 101.146 69.7587 101.146H2.80681C1.68823 101.146 0.5 102.024 0.5 103.096V252.891C0.5 253.692 0.973027 254.459 1.56424 255.025C2.15546 255.59 3.02743 255.906 3.86236 255.904L71.5475 255.727C72.3897 255.725 73.2133 255.399 73.8024 254.822C74.3916 254.244 74.7232 253.463 74.7075 252.656L71.7837 103.056Z"
        fill="#BDD0FB"
      />
      <g opacity="0.59">
        <path
          d="M33.3341 111.762L11.4326 111.69L11.4408 109.062L33.3177 109.129L33.3341 111.762Z"
          fill="white"
        />
        <path
          d="M33.3948 121.438L11.4033 121.342L11.4116 118.693L33.3784 118.783L33.3948 121.438Z"
          fill="white"
        />
        <path
          d="M33.4554 131.195L11.373 131.075L11.3813 128.404L33.4387 128.518L33.4554 131.195Z"
          fill="white"
        />
        <path
          d="M33.5157 141.032L11.3418 140.888L11.3501 138.195L33.499 138.333L33.5157 141.032Z"
          fill="white"
        />
        <path
          d="M33.5777 150.951L11.3115 150.781L11.32 148.066L33.5609 148.229L33.5777 150.951Z"
          fill="white"
        />
        <path
          d="M33.7022 171.039L11.249 170.819L11.2576 168.059L33.685 168.271L33.7022 171.039Z"
          fill="white"
        />
        <path
          d="M33.893 201.814L11.1533 201.515L11.1622 198.684L33.8753 198.975L33.893 201.814Z"
          fill="white"
        />
        <path
          d="M33.6395 160.954L11.2803 160.759L11.2888 158.021L33.6226 158.209L33.6395 160.954Z"
          fill="white"
        />
        <path
          d="M33.7656 181.211L11.2178 180.966L11.2265 178.182L33.7483 178.42L33.7656 181.211Z"
          fill="white"
        />
        <path
          d="M33.8288 191.468L11.1855 191.196L11.1942 188.389L33.8114 188.654L33.8288 191.468Z"
          fill="white"
        />
        <path
          d="M33.9578 212.246L11.1211 211.92L11.13 209.064L33.94 209.383L33.9578 212.246Z"
          fill="white"
        />
        <path
          d="M34.0234 222.769L11.0889 222.415L11.0978 219.535L34.0055 219.882L34.0234 222.769Z"
          fill="white"
        />
        <path
          d="M34.089 233.383L11.0557 233.001L11.0646 230.096L34.0709 230.47L34.089 233.383Z"
          fill="white"
        />
        <path
          d="M34.1555 244.089L11.0225 243.678L11.0315 240.748L34.1373 241.151L34.1555 244.089Z"
          fill="white"
        />
        <path
          d="M62.049 111.857L40.0101 111.784L39.9863 109.148L62.0004 109.215L62.049 111.857Z"
          fill="white"
        />
        <path
          d="M62.2273 121.564L40.0972 121.468L40.0732 118.811L62.1783 118.901L62.2273 121.564Z"
          fill="white"
        />
        <path
          d="M62.4083 131.353L40.1863 131.232L40.1621 128.553L62.3588 128.667L62.4083 131.353Z"
          fill="white"
        />
        <path
          d="M62.5892 141.222L40.2744 141.076L40.25 138.375L62.5394 138.514L62.5892 141.222Z"
          fill="white"
        />
        <path
          d="M62.7727 151.174L40.3645 151.003L40.3398 148.279L62.7223 148.443L62.7727 151.174Z"
          fill="white"
        />
        <path
          d="M63.1441 171.327L40.5465 171.106L40.5215 168.336L63.0929 168.55L63.1441 171.327Z"
          fill="white"
        />
        <path
          d="M63.7122 202.206L40.8245 201.906L40.7988 199.064L63.6598 199.358L63.7122 202.206Z"
          fill="white"
        />
        <path
          d="M62.9581 161.208L40.4555 161.012L40.4307 158.266L62.9072 158.454L62.9581 161.208Z"
          fill="white"
        />
        <path
          d="M63.332 181.533L40.6385 181.285L40.6133 178.492L63.2804 178.732L63.332 181.533Z"
          fill="white"
        />
        <path
          d="M63.5217 191.825L40.7315 191.551L40.7061 188.734L63.4697 189.001L63.5217 191.825Z"
          fill="white"
        />
        <path
          d="M63.9056 212.674L40.9196 212.346L40.8936 209.48L63.8527 209.801L63.9056 212.674Z"
          fill="white"
        />
        <path
          d="M64.0997 223.235L41.0145 222.878L40.9883 219.988L64.0464 220.337L64.0997 223.235Z"
          fill="white"
        />
        <path
          d="M64.2957 233.884L41.1102 233.499L41.084 230.584L64.2418 230.961L64.2957 233.884Z"
          fill="white"
        />
        <path
          d="M64.4936 244.627L41.2073 244.214L41.1807 241.273L64.4393 241.679L64.4936 244.627Z"
          fill="white"
        />
      </g>
      <path
        d="M130.108 267.677C180.667 267.677 221.653 226.69 221.653 176.131C221.653 125.572 180.667 84.5859 130.108 84.5859C79.5487 84.5859 38.5625 125.572 38.5625 176.131C38.5625 226.69 79.5487 267.677 130.108 267.677Z"
        fill="#A9C3F7"
      />
      <path
        d="M182.898 232.912C213.157 202.654 213.157 153.596 182.899 123.337C152.64 93.0792 103.582 93.0792 73.3236 123.338C43.0653 153.596 43.0653 202.654 73.3236 232.912C103.582 263.171 152.64 263.171 182.898 232.912Z"
        fill="white"
      />
      <g clipPath="url(#clip0_4807_62432)">
        <path
          d="M128.203 124.002C106.481 124.002 88.8281 141.655 88.8281 163.377C88.8281 170.727 90.8629 177.88 94.7346 184.049L125.534 234.452C126.059 235.305 126.847 235.83 127.766 235.962C129.012 236.158 130.391 235.634 131.113 234.387L162 183.524C165.675 177.487 167.578 170.465 167.578 163.377C167.578 141.655 149.925 124.002 128.203 124.002ZM128.203 183.064C117.179 183.064 108.516 174.139 108.516 163.377C108.516 152.549 117.375 143.689 128.203 143.689C139.031 143.689 147.891 152.549 147.891 163.377C147.891 174.074 139.359 183.064 128.203 183.064Z"
          fill="#4548EC"
        />
        <path
          d="M128.203 124.002C106.481 124.002 88.8281 141.655 88.8281 163.377C88.8281 170.727 90.8629 177.88 94.7346 184.049L125.534 234.452C126.059 235.305 126.847 235.83 127.766 235.962C129.012 236.158 130.391 235.634 131.113 234.387L162 183.524C165.675 177.487 167.578 170.465 167.578 163.377C167.578 141.655 149.925 124.002 128.203 124.002ZM128.203 183.064C117.179 183.064 108.516 174.139 108.516 163.377C108.516 152.549 117.375 143.689 128.203 143.689C139.031 143.689 147.891 152.549 147.891 163.377C147.891 174.074 139.359 183.064 128.203 183.064Z"
          fill="#4548EC"
        />
        <path
          d="M128.203 124.002V143.689C139.031 143.689 147.891 152.549 147.891 163.377C147.891 174.074 139.359 183.064 128.203 183.064V236C129.323 236.026 130.474 235.489 131.112 234.387L162 183.524C165.675 177.487 167.578 170.465 167.578 163.377C167.578 141.655 149.925 124.002 128.203 124.002Z"
          fill="#1B1ECC"
        />
      </g>
      <path
        d="M70.7516 245.002L59.7031 231.502L190.203 112.002L201.203 123.81L70.7516 245.002Z"
        fill="#A9C3F7"
      />
      <path
        opacity="0.7"
        d="M205.596 139.069C205.743 139.069 205.891 139.036 206.031 138.965C206.508 138.724 206.7 138.143 206.459 137.666C191.822 108.67 162.567 90.6562 130.108 90.6562C124.932 90.6562 119.744 91.1227 114.69 92.0447C114.164 92.14 113.816 92.6435 113.911 93.1695C114.007 93.6956 114.509 94.047 115.036 93.9468C119.977 93.0467 125.047 92.5907 130.108 92.5907C161.832 92.5907 190.426 110.197 204.732 138.537C204.902 138.875 205.243 139.069 205.596 139.069Z"
        fill="white"
      />
      <path
        d="M19.0929 291.779C19.0919 291.716 19.0963 291.651 19.1126 291.586C20.0751 287.77 24.0106 285.814 24.0106 285.814L25.9036 285.963C26.9919 289.326 27.6938 290.968 27.519 291.887C27.5142 291.912 27.5063 291.937 27.4995 291.962C25.9379 292.101 22.7239 292.192 19.0929 291.779Z"
        fill="url(#paint1_linear_4807_62432)"
      />
      <path
        d="M27.4993 291.962C27.415 292.269 27.1885 292.508 26.8986 292.569C24.6773 293.036 21.1466 292.66 19.6643 292.466C19.3373 292.423 19.0982 292.121 19.0928 291.779C22.7237 292.193 25.9378 292.102 27.4993 291.962Z"
        fill="#7D97F4"
      />
      <path
        d="M22.4512 282.867L23.2799 286.857C23.3407 287.15 23.5653 287.368 23.8375 287.394C24.1705 287.425 24.6447 287.444 25.1215 287.373C25.5491 287.311 25.8469 286.876 25.771 286.41L25.1949 282.867L22.4512 282.867Z"
        fill="url(#paint2_linear_4807_62432)"
      />
      <path
        d="M43.5832 291.928C41.5614 291.871 40.5158 291.633 39.9751 291.412C39.9738 291.613 39.975 291.818 39.9816 292.03C39.9885 292.256 40.1562 292.437 40.3625 292.436L51.4632 292.364C51.8175 292.362 52.0245 291.951 51.8709 291.626C50.4154 291.746 46.7085 292.015 43.5832 291.928Z"
        fill="#7D97F4"
      />
      <path
        d="M51.8714 291.627C51.858 291.598 51.8465 291.569 51.8275 291.543C50.8472 290.173 48.3503 287.445 43.4164 286.262L41.0494 286.188C41.0494 286.188 39.9955 288.019 39.9756 291.413C40.5163 291.634 41.5619 291.872 43.5837 291.928C46.709 292.016 50.416 291.747 51.8714 291.627Z"
        fill="url(#paint3_linear_4807_62432)"
      />
      <path
        d="M40.6104 282.599C40.6366 282.776 40.9611 285.457 41.0867 286.497C41.1166 286.744 41.2955 286.935 41.5212 286.962C41.9242 287.01 42.5764 287.054 43.147 286.937C43.4548 286.874 43.6776 286.578 43.6776 286.235V282.025L40.6104 282.599Z"
        fill="url(#paint4_linear_4807_62432)"
      />
      <path
        d="M24.0337 230.475C24.0337 230.475 20.2461 264.141 22.3503 285.183C22.3503 285.183 24.8753 285.183 26.1378 284.762C26.1378 284.762 30.0736 251.845 31.3469 242.425C31.3948 242.07 31.9018 242.054 31.9714 242.406C33.5423 250.33 39.7125 281.407 40.4462 284.341C40.4462 284.341 42.5504 285.183 44.2337 284.341C44.2337 284.341 40.8671 239.312 38.3421 231.316L24.0337 230.475Z"
        fill="#070975"
      />
      <path
        d="M27.5678 179.836L25.9746 190.609C25.9746 190.609 30.4254 192.654 33.5419 190.522L32.8709 182.918L27.5678 179.836Z"
        fill="url(#paint5_linear_4807_62432)"
      />
      <path
        d="M32.2216 171.921C32.3293 172.022 36.7644 180.732 36.7644 180.732L31.7375 183.158L26.3076 175.528C26.3076 175.528 30.4196 170.224 32.2216 171.921Z"
        fill="url(#paint6_linear_4807_62432)"
      />
      <path
        d="M28.5313 175.739C28.4416 175.971 28.4637 176.23 28.5916 176.443L31.0986 180.623C31.1367 180.686 31.1819 180.743 31.2361 180.794C31.5345 181.071 32.5556 181.879 33.345 180.779C34.0179 179.842 34.6492 178.989 35.3256 178.638C35.7206 178.432 36.2067 178.596 36.4073 178.994C36.8203 179.813 37.6205 181.481 38.1231 183.064C38.2491 183.461 38.0443 183.887 37.6586 184.043C36.6407 184.455 34.6291 185.201 32.8438 185.447C32.5507 185.488 32.2602 185.364 32.0858 185.125C31.3178 184.073 29.1531 181.132 28.4142 180.396C27.7278 179.713 26.461 179.97 25.8903 180.134C25.6736 180.197 25.4429 180.167 25.2497 180.05C24.6705 179.702 23.6598 178.833 24.5844 177.362C24.8143 176.997 24.6971 176.509 24.3361 176.272C23.6897 175.847 22.9879 175.048 23.6565 173.755C24.3332 172.446 25.5417 172.329 26.3647 172.43C26.7289 172.474 27.0987 172.283 27.2383 171.944C27.3005 171.793 27.4234 171.664 27.652 171.618C28.0834 171.53 28.3666 171.136 28.2819 170.704C28.1368 169.963 28.2462 169.001 29.4287 168.351C31.5976 167.158 33.4974 169.102 33.9805 170.742C34.4637 172.382 32.0386 173.541 30.5132 173.735C29.3928 173.877 28.7784 175.1 28.5313 175.739Z"
        fill="url(#paint7_linear_4807_62432)"
      />
      <path
        d="M29.3559 181.932C29.3559 181.932 28.3914 179.11 27.1569 179.214C25.9223 179.317 24.9507 180.547 26.4806 181.93C28.3839 183.649 29.3559 181.932 29.3559 181.932Z"
        fill="url(#paint8_linear_4807_62432)"
      />
      <path
        d="M16.458 191.337C16.458 191.337 32.4498 188.812 45.0748 192.178L44.2331 205.224C44.2331 205.224 40.8665 223.32 38.3415 231.316C38.3415 231.316 28.6622 232.999 24.033 230.474C24.033 230.474 20.2455 207.749 18.1413 204.383C18.1413 204.383 16.0371 195.545 16.458 191.337Z"
        fill="#7256C5"
      />
      <path
        d="M16.4579 191.338C16.4579 191.338 -8.37139 218.271 20.8767 228.582V226.478C20.8767 226.478 9.93509 217.219 18.3518 204.594C18.3518 204.594 17.2996 192.6 16.4579 191.338Z"
        fill="url(#paint9_linear_4807_62432)"
      />
      <path
        d="M40.348 207.45C40.348 207.45 76.8787 197.506 58.7398 171.934L57.5126 173.671C57.5126 173.671 61.9702 190.306 43.8664 191.952C43.8664 191.952 40.1851 204.73 40.348 207.45Z"
        fill="url(#paint10_linear_4807_62432)"
      />
      <path
        d="M58.8634 172.064C58.8634 172.064 59.2749 167.127 56.8061 166.716C54.3374 166.304 53.5145 168.773 53.1031 170.007C52.6916 171.242 56.8061 173.71 57.629 173.71C58.4519 173.71 58.8634 172.064 58.8634 172.064Z"
        fill="url(#paint11_linear_4807_62432)"
      />
      <path
        d="M21.0876 226.687C21.0876 226.687 24.8751 224.162 26.5584 225.004C28.2418 225.845 28.2418 227.108 28.2418 227.108C28.2418 227.108 27.4001 228.791 26.1376 228.37C24.8751 227.95 21.9292 228.791 20.6667 228.37C20.6667 228.37 20.2459 226.687 21.0876 226.687Z"
        fill="url(#paint12_linear_4807_62432)"
      />
      <path
        d="M4.11248 137.835L9.59372 164.376C10.0187 166.434 12.053 167.741 14.1005 167.268C21.9392 165.456 40.7647 162.252 56.5945 168.545C58.7215 169.391 61.1055 168.179 61.6429 165.954L68.8479 136.126C69.2452 134.481 68.4926 132.77 67.0065 131.96C49.889 122.637 26.383 120.744 5.77871 133.912C4.46478 134.751 3.79713 136.308 4.11248 137.835Z"
        fill="#87A0F9"
      />
      <path
        d="M38.8338 139.895C38.7348 142.978 36.2075 145.54 33.1988 145.629C30.2011 145.717 27.8397 143.317 27.9148 140.256C27.9903 137.181 30.4929 134.59 33.5145 134.48C36.5473 134.37 38.9333 136.799 38.8338 139.895Z"
        fill="url(#paint13_linear_4807_62432)"
      />
      <path
        d="M42.2879 153.268C40.7619 149.765 37.2723 147.365 33.1458 147.483C29.0402 147.599 25.4608 150.177 23.7686 153.726L42.2879 153.268Z"
        fill="url(#paint14_linear_4807_62432)"
      />
      <path
        d="M34.0757 129.868C25.6275 130.215 18.7397 137.472 18.6027 145.977C18.4675 154.368 24.9679 160.96 33.2059 160.801C41.5404 160.641 48.6462 153.642 48.9925 145.065C49.3438 136.369 42.6254 129.518 34.0757 129.868ZM21.1572 145.901C21.2851 138.849 27.0077 132.854 33.9995 132.58C36.5956 132.479 38.9927 133.184 40.9726 134.477L24.754 154.88C22.4768 152.653 21.0922 149.477 21.1572 145.901ZM33.2789 158.209C30.7459 158.263 28.4168 157.549 26.4927 156.282L42.7603 135.915C45.0953 138.207 46.4767 141.481 46.3365 145.145C46.0648 152.246 40.1926 158.063 33.2789 158.209Z"
        fill="url(#paint15_linear_4807_62432)"
      />
      <mask id="path-138-inside-1_4807_62432" fill="white">
        <path d="M95.7402 212.502C95.4846 212.227 95.5004 211.797 95.7755 211.541L128.149 181.463C128.424 181.207 128.854 181.223 129.11 181.498C129.366 181.773 129.35 182.203 129.075 182.459L96.7012 212.537C96.4261 212.793 95.9958 212.777 95.7402 212.502Z" />
      </mask>
      <path
        d="M95.7402 212.502C95.4846 212.227 95.5004 211.797 95.7755 211.541L128.149 181.463C128.424 181.207 128.854 181.223 129.11 181.498C129.366 181.773 129.35 182.203 129.075 182.459L96.7012 212.537C96.4261 212.793 95.9958 212.777 95.7402 212.502Z"
        fill="#C2D0F0"
      />
      <path
        d="M100.54 216.669L132.914 186.591L123.384 176.335L91.0109 206.413L100.54 216.669ZM124.31 177.331L91.9366 207.409L101.466 217.666L133.839 187.587L124.31 177.331ZM91.9366 207.409C94.4937 205.033 98.4926 205.18 100.868 207.737L90.612 217.267C93.4991 220.374 98.3585 220.553 101.466 217.666L91.9366 207.409ZM123.982 186.263C121.606 183.706 121.753 179.707 124.31 177.331L133.839 187.587C136.947 184.7 137.125 179.841 134.238 176.733L123.982 186.263ZM132.914 186.591C130.357 188.967 126.358 188.82 123.982 186.263L134.238 176.733C131.351 173.626 126.492 173.447 123.384 176.335L132.914 186.591ZM91.0109 206.413C87.9035 209.3 87.725 214.159 90.612 217.267L100.868 207.737C103.244 210.295 103.097 214.293 100.54 216.669L91.0109 206.413Z"
        fill="#E5EDFD"
        mask="url(#path-138-inside-1_4807_62432)"
      />
      <path
        d="M214.32 191.887C214.32 191.887 194.754 199.695 196.391 205.835C198.029 211.975 208.671 201.742 208.671 201.742L214.32 191.887Z"
        fill="#E88D89"
      />
      <path
        d="M222.032 174.252C222.032 174.252 224.648 175.524 225.129 176.986C225.515 178.159 228.408 178.31 228.694 180.617C228.841 181.808 229.723 182.762 230.909 182.944C233.863 183.397 238.417 184.931 239.145 190.061C239.701 193.976 237.705 195.461 235.61 195.975C234.072 196.352 233.049 197.849 233.361 199.402C233.659 200.892 233.214 202.614 230.633 203.976C224.849 207.028 219.072 196.746 219.072 196.746L217.889 178.792L222.032 174.252Z"
        fill="url(#paint16_linear_4807_62432)"
      />
      <path
        d="M241.508 287.178L241.882 290.255C241.953 290.839 242.413 291.301 242.997 291.367C243.983 291.48 245.566 291.596 247.115 291.432C247.795 291.36 248.236 290.672 248.029 290.02C247.652 288.832 246.961 287.049 245.965 286H242.552C241.921 286 241.432 286.552 241.508 287.178Z"
        fill="url(#paint17_linear_4807_62432)"
      />
      <path
        d="M219.022 237L218.456 241.527C218.456 241.527 220.353 267.631 220.691 278.073C220.744 279.71 220.432 281.328 219.799 282.723L216.5 290L224.885 283.28L225.052 281.89L223.679 279.326L225.477 250.083C225.583 248.365 225.322 246.642 224.725 245.121L222.991 240.695L219.022 237Z"
        fill="#E88D89"
      />
      <path
        d="M216.243 290H219.054C219.58 290 220.076 289.769 220.397 289.37C221.273 288.28 223.089 286.153 223.957 286.098C225.126 286.023 224.976 290 224.976 290H225.631L226.461 285.058C226.67 283.814 226.024 282.583 224.857 282C224.857 282 224.59 283.891 223.142 284.728C221.693 285.564 217.247 288.56 217.247 288.56C217.247 288.56 216.703 288.486 216.105 288.589C215.218 288.743 215.342 290 216.243 290Z"
        fill="url(#paint18_linear_4807_62432)"
      />
      <path
        d="M225.5 242.765C225.5 242.765 237.115 269.64 238.962 275.776C240.808 281.913 241.455 287.031 241.48 287.516C241.519 288.274 242.291 289 244.42 289C245.519 289 246.057 288.463 246.32 287.943C246.545 287.499 246.557 286.944 246.367 286.476C245.695 284.818 243.563 279.517 242.773 277.113C241.831 274.243 239.802 261.235 238.69 256.713C237.578 252.19 236.321 247.284 231.477 242.765C231.477 242.765 228.152 238.793 225.5 242.765Z"
        fill="#E88D89"
      />
      <path
        d="M223.61 217.265C220.695 204.91 228.319 198.876 228.319 198.876C227.909 193.964 214.929 191.414 214.929 191.414C214.929 191.414 206.827 197.338 207.788 201.974C208.352 204.692 213.483 218.251 213.483 218.251C213.483 218.251 218.229 220.497 223.61 217.265Z"
        fill="#2A0E7D"
      />
      <path
        d="M229.658 221.917C228.473 219.043 223.202 217 223.202 217C217.827 219.598 213.088 217.793 213.088 217.793C213.088 217.793 212.025 221.063 212.758 224.102C213.492 227.14 218.094 246.67 218.094 246.67C225.347 247.852 236.5 245.48 236.5 245.48C231.881 238.879 230.843 224.79 229.658 221.917Z"
        fill="#5355FF"
      />
      <path
        d="M220.227 183.25L222.597 193.897C222.824 194.835 221.969 194.681 221.021 194.502C219.468 194.21 217.467 193.607 216.798 192.398C216.73 192.275 216.696 192.137 216.676 191.997L215.658 184.614C215.577 184.028 215.894 183.46 216.434 183.22L218.4 182.349C219.156 182.013 220.032 182.445 220.227 183.25Z"
        fill="#E88D89"
      />
      <path
        d="M217.445 173.111C217.445 173.111 214.638 174.296 212.729 178.353C210.82 182.41 212.245 184.283 214.036 184.54C215.826 184.797 218.504 184.758 221.336 182.137C224.169 179.517 221.094 171.706 217.445 173.111Z"
        fill="#E88D89"
      />
      <path
        d="M219.432 179.972C219.432 179.972 221.55 174.037 216.288 173.967L215.05 174.833C215.05 174.833 213.119 171.542 216.288 169.971C219.457 168.4 223.166 169.698 224.515 173.967C225.863 178.236 226.093 181.094 223.85 183.137C221.606 185.179 220.682 182.863 220.682 182.863C220.682 182.863 221.903 180.953 221.406 179.931C220.909 178.909 219.762 180.142 219.762 180.142L219.432 179.972Z"
        fill="url(#paint19_linear_4807_62432)"
      />
      <path
        d="M220.022 180.634C220.022 180.634 221.093 177.577 222.522 178.794C223.95 180.012 221.361 181.618 220.347 182.139L220.022 180.634Z"
        fill="#E88D89"
      />
      <path
        d="M228.319 198.876C228.319 198.876 230.775 211.565 220.132 214.84C209.49 218.114 202.062 203.742 202.062 203.742C202.062 203.742 200.075 201.741 200.075 199.285C200.075 196.829 202.122 195.088 202.122 195.088C202.122 195.088 205.396 199.694 205.396 202.15C205.396 204.606 215.63 211.565 219.314 209.518C222.894 207.529 222.946 203.458 222.748 201.547C222.67 200.795 222.899 200.046 223.396 199.477C224.498 198.217 226.906 196.897 228.319 198.876Z"
        fill="#E88D89"
      />
      <path
        d="M199.3 204.398L199.607 208.684C199.644 209.209 200.211 209.53 200.674 209.279C201.097 209.049 201.61 208.614 202.122 207.795C203.249 205.995 202.307 203.777 199.928 203.742C199.567 203.737 199.275 204.038 199.3 204.398Z"
        fill="#E88D89"
      />
      <path
        d="M200.075 220.161H202.122V164.492H200.075V220.161Z"
        fill="#7291FF"
      />
      <path
        d="M227.301 129.864L223.534 167.187C223.271 169.795 220.993 171.729 218.377 171.566L186.084 169.547C183.628 169.394 181.67 167.435 181.519 164.978L179.124 125.963C178.94 122.969 181.476 120.52 184.461 120.808L222.916 124.519C225.606 124.778 227.572 127.175 227.301 129.864Z"
        fill="#7291FF"
      />
      <path
        d="M207.411 142.221C207.32 145.038 205.011 147.379 202.261 147.46C199.522 147.541 197.365 145.347 197.433 142.55C197.502 139.741 199.789 137.373 202.55 137.273C205.321 137.172 207.501 139.392 207.411 142.221Z"
        fill="url(#paint20_linear_4807_62432)"
      />
      <path
        d="M210.567 154.438C209.172 151.238 205.984 149.045 202.213 149.152C198.462 149.259 195.191 151.614 193.645 154.857L210.567 154.438Z"
        fill="url(#paint21_linear_4807_62432)"
      />
      <path
        d="M203.062 133.059C195.343 133.375 189.049 140.007 188.924 147.778C188.8 155.445 194.74 161.469 202.268 161.324C209.883 161.177 216.376 154.782 216.693 146.945C217.014 138.999 210.875 132.738 203.062 133.059ZM191.258 147.708C191.375 141.264 196.604 135.786 202.993 135.537C205.365 135.444 207.555 136.088 209.364 137.27L194.545 155.914C192.464 153.878 191.199 150.976 191.258 147.708ZM202.334 158.955C200.02 159.004 197.891 158.352 196.133 157.194L210.998 138.584C213.131 140.678 214.394 143.67 214.266 147.018C214.017 153.506 208.652 158.822 202.334 158.955Z"
        fill="url(#paint22_linear_4807_62432)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4807_62432"
          x1="283.661"
          y1="285.541"
          x2="97.9791"
          y2="85.122"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAE3FE" />
          <stop offset="1" stopColor="#E9EFFD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4807_62432"
          x1="24.173"
          y1="317.273"
          x2="23.67"
          y2="302.184"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7C27DD" />
          <stop offset="1" stopColor="#2B41D9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4807_62432"
          x1="24.7713"
          y1="279.027"
          x2="23.0838"
          y2="293.754"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBBBA" />
          <stop offset="1" stopColor="#FF928E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4807_62432"
          x1="44.7509"
          y1="326.604"
          x2="45.2539"
          y2="311.514"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7C27DD" />
          <stop offset="1" stopColor="#2B41D9" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4807_62432"
          x1="42.5482"
          y1="280.911"
          x2="40.9697"
          y2="294.688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBBBA" />
          <stop offset="1" stopColor="#FF928E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4807_62432"
          x1="25.9746"
          y1="185.664"
          x2="33.542"
          y2="185.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBBBA" />
          <stop offset="1" stopColor="#FF928E" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4807_62432"
          x1="30.7606"
          y1="173.567"
          x2="33.8758"
          y2="191.899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBBBA" />
          <stop offset="1" stopColor="#FF928E" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4807_62432"
          x1="27.4844"
          y1="182.244"
          x2="36.6648"
          y2="172.492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4807_62432"
          x1="28.0572"
          y1="193.577"
          x2="27.503"
          y2="180.704"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBBBA" />
          <stop offset="1" stopColor="#FF928E" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_4807_62432"
          x1="13.7504"
          y1="191.338"
          x2="13.7504"
          y2="228.582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8665E7" />
          <stop offset="1" stopColor="#4B3981" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_4807_62432"
          x1="58.0867"
          y1="185.388"
          x2="25.1343"
          y2="226.884"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7256C5" />
          <stop offset="1" stopColor="#7256C5" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_4807_62432"
          x1="54.2422"
          y1="164.3"
          x2="58.5623"
          y2="178.495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBBBA" />
          <stop offset="1" stopColor="#FF928E" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_4807_62432"
          x1="27.8163"
          y1="224.282"
          x2="14.3495"
          y2="235.784"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBBBA" />
          <stop offset="1" stopColor="#FF928E" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_4807_62432"
          x1="26.0777"
          y1="106.605"
          x2="40.6816"
          y2="173.544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_4807_62432"
          x1="23.2088"
          y1="108.489"
          x2="37.394"
          y2="173.508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_4807_62432"
          x1="70.5542"
          y1="-24.8833"
          x2="58.9598"
          y2="28.8169"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF928E" />
          <stop offset="1" stopColor="#B3C8F4" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_4807_62432"
          x1="217.431"
          y1="163.78"
          x2="225.191"
          y2="183.247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_4807_62432"
          x1="295.583"
          y1="90.2546"
          x2="269.343"
          y2="192.773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F52FF" />
          <stop offset="1" stopColor="#4042E2" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_4807_62432"
          x1="275.495"
          y1="84.1479"
          x2="250.525"
          y2="186.059"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F52FF" />
          <stop offset="1" stopColor="#4042E2" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_4807_62432"
          x1="215.802"
          y1="164.429"
          x2="223.562"
          y2="183.895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_4807_62432"
          x1="195.754"
          y1="111.802"
          x2="209.099"
          y2="172.967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_4807_62432"
          x1="193.133"
          y1="113.521"
          x2="206.095"
          y2="172.933"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_4807_62432"
          x1="232.42"
          y1="10.0645"
          x2="220.825"
          y2="63.7646"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF4F4" />
          <stop offset="1" stopColor="#B3C8F4" />
        </linearGradient>
        <clipPath id="clip0_4807_62432">
          <rect
            width="112"
            height="112"
            fill="white"
            transform="translate(72.2031 124.002)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoLocationFound;
